import React from 'react'
import styled, { boldRolloverFix } from '../../constants/theme'
import { FormElementProps } from './FormElementParts'

interface State {
  checked: boolean
}

class SwitchElement extends React.Component<FormElementProps, State> {
  constructor(props) {
    super(props)
    this.state = {
      checked: props.value === 'true',
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setChecked(this.props.value)
    }
  }

  handleChange = e => {
    const { name } = this.props
    const value = e.target.checked ? 'true' : 'false'
    const { onChange } = this.props
    if (onChange) {
      onChange({ name, value })
    }
    this.setChecked(value)
  }

  setChecked = value => {
    this.setState({
      checked: value === 'true',
    })
  }

  render() {
    const { disabled, isRequired, label, name } = this.props
    const { checked } = this.state
    const labelId = `label-${name}`
    return (
      <Switch>
        <SwitchInput
          aria-checked={checked}
          aria-labelledby={labelId}
          checked={checked}
          disabled={disabled}
          id={name}
          name={name}
          onChange={this.handleChange}
          required={isRequired}
          type='checkbox'
          className='switch'
        />
        <Label htmlFor={name} id={labelId} title={label}>
          {label}
        </Label>
        <Slider />
      </Switch>
    )
  }
}

const SwitchInput = styled.input({
  '&:disabled': {
    cursor: 'not-allowed',
  },
  '&:focus ~': {
    fontWeight: 'bold',
  },
  '&:hover': {
    cursor: 'pointer',
  },
  height: '100%',
  left: 0,
  opacity: 0,
  position: 'absolute',
  top: 0,
  width: '100%',
  zIndex: 1,
})

const Label = styled.label({
  '&:after': boldRolloverFix,
})

export const Slider = styled.span(
  {
    '&::before': {
      borderRadius: '50%',
      content: '""',
      height: 16,
      left: -2,
      position: 'absolute',
      top: -1,
      transition: '.4s',
      width: 16,
    },
    borderRadius: 34,
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0,
    transition: '.4s',
    width: 30,
  },
  ({ theme }) => ({
    '&::before': {
      backgroundColor: theme.background,
      border: `2px solid ${theme.grey}`,
    },
    backgroundColor: theme.greyLight,
    border: `2px solid ${theme.grey}`,
    'input:checked ~ &': {
      backgroundColor: theme.primary,
    },
    'input:checked ~ &::before': {
      transform: 'translateX(14px)',
    },
  }),
)

const Switch = styled.li(
  {
    display: 'inline-block',
    height: 18,
    lineHeight: 1.1,
    paddingLeft: 40,
    position: 'relative',
    width: '100%',
  },
  ({ theme }) => ({
    color: theme.text,
    fontFamily: theme.fontFamily,
  }),
)

export default SwitchElement
